<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <div class="service-list">
                <draggable v-model="config[field.key]">
                <el-row class="service-item" v-for="(item,index) in config[field.key]" :key="index" type="flex" justify="space-between">
                    <div class="link-name" v-text="config[field.key][index]['title']"></div>
                    <el-button size="small" @click="removeArticleItem(index)" class="del-btn">删除</el-button>
                </el-row>
                </draggable>
            </div>
            <el-button size="small" @click="openDialog">添加服务</el-button>
        </el-form-item>
        <el-dialog title="请选择服务" :visible.sync="dialog.visible" @close='closeDialog'>
            <item-list @close="closeDialog" :url="tableList.url" :searchField="tableList.searchField"
                          :priceField="tableList.priceField" :titleField="tableList.titleField"
                          :resultArrayName="tableList.resultArrayName" :multi="tableList.multi" :idList="idList" @select="select"></item-list>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
    .service-list{
        margin-top: -5px;
    }
    .service-item{
        cursor: pointer;
        padding: 5px 5px 5px 10px;
        &:hover{
            background: #F5F7FA;
        }
    }
    .link-name{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        padding-right: 20px;
    }
    .del-btn{
        height: 32px;
        margin-top: 4px;
    }
</style>

<script>

  import Util from '@/js/util';
  import _ from 'lodash';
  import draggable from 'vuedraggable';
  export default {
    name: 'tms-type-service-list',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        dialog: {
          visible: false
        },
        linkNameList: {},
        currentIndex: 0,
        activeName: 'normal',
        tableList: {
          url: 'wdzg/b/cms/service/list',
          ssearchField: 'title_like',
          priceField: 'price',
          titleField: 'title',
          resultArrayName: 'service_list',
          multi: true
        },
      }
    },

    computed: {
      idList() {
        let list = [];
        this.config[this.field.key].map((val) => {
          list.push(val.id);
        })
        return list;
      }
    },

    components: {
      draggable
    },

    created() {
    },

    methods: {
      openDialog() {
        this.dialog.visible = true;
      },
      removeArticleItem(index) {
        this.config[this.field.key].splice(index, 1);
      },
      handleUpload(src, index) {
        this.$set(this.config[this.field.key][index], image_url, src);
      },
      openDialog(index) {
        this.currentIndex = index;
        this.dialog.visible = true;
      },
      closeDialog() {
        this.dialog.visible = false;
      },
      select(row) {
        let item = _.cloneDeep(row);
        delete item.rich_detail;
        item.cms_url = '/cms/page/biz/service.html?id=' + item.id;
        item.price = Util.filterPriceToFen(item.price);
        this.config[this.field.key].push(item);
      },
      unSelect(row, index){
        this.config[this.field.key].splice(index, 1);
      }
    }
  }

</script>
